import type { RedirectLoginOptions } from '@auth0/auth0-react';

export class EmailLoginUnavailableError extends Error {
  constructor() {
    super('Email sign-in is not available yet. Please use Google or contact your administrator.');
  }
}

/** Refuse an older backend before it can provision an email identity as customer. */
export async function requireEmailLogin(apiUrl: string): Promise<void> {
  try {
    const response = await fetch(`${apiUrl}/functions/v1/auth-exchange`, {
      cache: 'no-store',
      signal: AbortSignal.timeout(10000),
    });
    const body = await response.json();
    if (!response.ok || body.staff_email_login !== true) throw new EmailLoginUnavailableError();
  } catch {
    throw new EmailLoginUnavailableError();
  }
}

/** Staff email login uses Universal Login + PKCE, never a separate OTP token store. */
export function staffLoginOptions(email?: string): RedirectLoginOptions {
  return {
    authorizationParams: email === undefined
      ? { connection: 'google-oauth2', prompt: 'login' }
      : { connection: 'email', login_hint: email.trim().toLowerCase(), prompt: 'login' },
  };
}
